import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class PayrollInsuranceReportProvider {

  private _service: string = 'payroll';
  private _model: string = 'payrollinsurancereport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadPVFgenExcel(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadPVFgenExcel';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downloadSsoSummary(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadSsoSummary';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downloadPdfSso(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadPdfSso';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downloadSsoDetail(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadSsoDetail';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downloadSsoEmptyR(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadSsoEmptyR';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public downloadSsoEmpty(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadSsoEmpty';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public doSSO609(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'doSSO609';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/payroll-insurance-report/payroll-insurance-report.ts